export default {
  confirmUpdate: 'Änderungen an diesem Rezept speichern?',
  recipeExists: 'Rezept existiert',
  recipeName: 'Rezeptname',
};
